
const mobileLayout = () => import('../views/pages/mobile/index.vue');
const login = () => import('../views/pages/mobile/login/login.vue'); // 展商登录页      
const loginAlogin = () => import('../views/pages/mobile/login/components/alogin.vue'); // 密码登录
const exList = () => import('../views/pages/mobile/ex-list.vue'); // 展会列表
const exAreaList = () => import('../views/pages/mobile/ex-area-list.vue'); // 报名展商-展区列表
const exCompanyList = () => import('../views/pages/mobile/ex-company-list.vue'); // 报名展商-展区列表
const exAllCompanyList = () => import('../views/pages/mobile/ex-all-company-list.vue'); // 报名展商-展区列表
const exCompanyDetails = () => import('../views/pages/mobile/ex-company-details.vue'); // 报名展商-企业列表-详情

const mobileRouter = [
  {
    path: '/mobile-backend', redirect: '/mobile-backend/login/alogin', name: 'mobile-backend', component: mobileLayout,
    children: [
      {
        path: 'ex-list', name: 'ex-list', component: exList, meta: { requireAuth: true },
      },
      {
        path: 'ex-area-list', name: 'ex-area-list', component: exAreaList, meta: { requireAuth: true },
      },
      {
        path: 'ex-all-company-list', name: 'ex-all-company-list', component: exAllCompanyList, meta: { requireAuth: true },
      },
      {
        path: 'ex-company-list', name: 'ex-company-list', component: exCompanyList, meta: { requireAuth: true },
      },
      {
        path: 'ex-company-details', name: 'ex-company-details', component: exCompanyDetails, meta: { requireAuth: true },
      },
      {
        path: 'login', redirect: '/mobile-backend/login/alogin', name: 'mobile-login', component: login, meta: { requireAuth: false },
        children: [
          { path: 'alogin', name: 'alogin', component: loginAlogin, meta: { requireAuth: false } },
        ],
      },
    ]
  },
]


export {
  mobileRouter,
}; 
